import React from 'react';
import { FooterLink, FooterText } from "./FormComponents";
export default function TermsAndPrivacyMessage(_ref) {
  let {
    type
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(FooterText, null, "By signing ".concat(type === 'login' ? 'in' : 'up', " to Anchor, you agree to our ")), /*#__PURE__*/React.createElement(FooterLink, {
    toExternalLink: "https://www.sayanchor.com/terms-of-contact",
    target: "_blank"
  }, "Terms of Service"), /*#__PURE__*/React.createElement(FooterText, null, " and "), /*#__PURE__*/React.createElement(FooterLink, {
    toExternalLink: "https://www.sayanchor.com/privacy-policy",
    target: "_blank"
  }, "Privacy policy"), /*#__PURE__*/React.createElement(FooterText, null, "."));
}